import { groupChatMessagesTogether } from '@lumapps/lumx-chat/utils/groupChatMessagesTogether';
import { generateUUID } from '@lumapps/utils/string/generateUUID';

import { AskAiChatAgentMessage, AskAiChatMessage, AskAiChatUserMessage } from './types';

export type AskAiChatMessageWithoutID = Omit<AskAiChatAgentMessage, 'id'> | Omit<AskAiChatUserMessage, 'id'>;

/**
 * Generates a new Ask AI Chat message with a unique ID.
 *
 * This function takes a message object (either AskAiChatAgentMessage or AskAiChatUserMessage) without an ID,
 * and returns a new message object with a generated unique ID.
 */
export const generateMessageID = (message: AskAiChatMessageWithoutID): AskAiChatMessage => ({
    ...message,
    id: generateUUID(),
});

/**
 * Group the user queries with the corresponding agent response.
 */
export const groupAskAiChatQuestionWithAnswer = (messages: AskAiChatMessage[]) =>
    groupChatMessagesTogether(
        messages,
        (message, previousMessage) =>
            (message.role === 'agent' && previousMessage.role === 'user') || message.role === previousMessage.role,
    );
